export default "__VITE_ASSET__xera_dts__"